import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";
// @material-ui/core components
import { makeStyles } from "@material-ui/core/styles";

// @material-ui/icons

// core components
import Header from "components/Header/Header.js";
import Footer from "components/Footer/Footer.js";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import HeaderLinks from "components/Header/HeaderLinks.js";
import Parallax from "components/Parallax/Parallax.js";
import { Link } from "react-router-dom";

import styles from "assets/jss/material-kit-react/views/mainPage.js";

// Sections for this page
import ProjectSection from "./Sections/ProjectSection.js";
import BriefSection from "./Sections/BriefSection.js";

const useStyles = makeStyles(styles);

export default function MainPage(props) {
  const classes = useStyles();
  const { ...rest } = props;
  return (
    <div>
      <Header
        color="transparent"
        brand="Inxudianz"
        rightLinks={<HeaderLinks />}
        fixed
        changeColorOnScroll={{
          height: 400,
          color: "dark",
        }}
        {...rest}
      />
      <Parallax filter image={require("assets/img/bg.png")}>
        <div id="stars"></div>
        <div id="stars2"></div>
        <div id="stars3"></div>
        <div className={classes.container}>
          <GridContainer>
            <GridItem xs={12} sm={12} md={6}>
              <h1 className={classes.title}>My Creative Tech Journey</h1>
              <h4>
                <i>&quot;Adapting new tech one step at a time.&quot;</i>
              </h4>
              <br />
              <Link to="/profile">
                <Button
                  color="primary"
                  size="lg"
                  target="_self"
                  rel="noopener noreferrer"
                  round
                >
                  Get to know me!
                </Button>
              </Link>
            </GridItem>
          </GridContainer>
        </div>
      </Parallax>
      <div className={classNames(classes.main, classes.mainRaised)}>
        <div className={classes.container}>
          <BriefSection />
          <ProjectSection />
        </div>
      </div>
      <Footer />
    </div>
  );
}
